export const postBlog = async (blogData) => {
    try {
      const response = await fetch('https://blog-swipe-backend.vercel.app/createBlogPost', {
        method: 'POST',
        body: blogData, // Send FormData
      });
  
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to post blog');
      }
  
      const result = await response.json();

      // console.log(result);
      // console.log("resultsdsdsdsdsdsdsdsd");

      return result; // Return the response data
    } catch (error) {
      console.error('Error posting blog:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  };
  